import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { constant } from "common/constant";
import { getApi } from "common/services/api";
export const getContactList = createAsyncThunk(
  "contactLead/getContactList",
  async (user, { rejectWithValue }) => {
    try {
      const result = await getApi(
        user.role === "superAdmin"
          ? "api/contact/"
          : `api/contact/?createBy=${user._id}`
      );
      return result?.data?.data;
    } catch (error) {
      console.error("Error fetching contacts:", error);
      toast.error(constant.somethingWrong);
      return rejectWithValue(error.message || constant.somethingWentWrong);
    }
  }
);

export const getLeadList = createAsyncThunk(
  "contactLead/getLeadList",
  async (user, { rejectWithValue }) => {
    try {
      const result = await getApi(
        user.role === "superAdmin"
          ? "api/lead/"
          : `api/lead/?createBy=${user._id}`
      );
      return result?.data?.data;
    } catch (error) {
      console.error("Error fetching leads:", error);
      toast.error(constant.somethingWrong);
      return rejectWithValue(error.message || constant.somethingWentWrong);
    }
  }
);

const contactLeadSlice = createSlice({
  name: "contactLead",
  initialState: {
    contacts: [],
    leads: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContactList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContactList.fulfilled, (state, action) => {
        state.loading = false;
        state.contacts = action.payload;
      })
      .addCase(getContactList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getLeadList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLeadList.fulfilled, (state, action) => {
        state.loading = false;
        state.leads = action.payload;
      })
      .addCase(getLeadList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default contactLeadSlice.reducer;
